import Dimmer from 'components/ui/Dimmer/Dimmer';
import styles from './Modal.module.scss';
import cn from 'lib/cn';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import Icon from 'components/layout/Icon/Icon';

interface Props {
  open?: boolean;
  children: React.ReactNode;
  onClose: () => void;
  footer?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  closeIcon?: boolean;
}

const Modal: React.FC<Props> = ({ open, children, onClose, footer, size, closeIcon }) => {
  const [visible, setVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const bodyRef = useRef<HTMLBodyElement | null>(null);

  useEffect(() => {
    bodyRef.current = document.querySelector('body') as HTMLBodyElement;
    if (open) {
      setIsOpen(true);
      bodyRef.current.style.overflow = 'hidden';
      setTimeout(() => setVisible(true), 50);
    } else {
      setVisible(false);
      bodyRef.current.style.overflow = 'auto';
      setTimeout(() => setIsOpen(false), 250);
    }
  }, [open]);

  return (
    <>
      {isOpen &&
        ReactDOM.createPortal(
          <div className={cn(styles.outerModalContainer, visible && styles.visible)}>
            <Dimmer dark onClick={() => onClose()} />
            <div className={cn(styles.modal, visible && styles.inPosition, size && styles[size])}>
              {closeIcon && (
                <div className={styles.closeIcon} onClick={() => onClose()}>
                  <Icon name="close" />
                </div>
              )}
              <div className={styles.content}>{children}</div>
              {footer && <div className={styles.footer}>{footer}</div>}
            </div>
          </div>,
          bodyRef.current as HTMLBodyElement,
        )}
    </>
  );
};

export default Modal;
